/* Homellence Bewegungskonzept (V19, 26.10.2026) - steuert hl-motion.css
   - Bloecke unterhalb des ersten Bildschirms werden scharf geschaltet (data-hlm) und blenden einmal ein, wenn sie ins Bild kommen.
   - Nichts davon laeuft im Theme-Editor, bei fehlendem IntersectionObserver oder wenn der Besucher weniger Bewegung wuenscht
     (dann nur weiches Einblenden ueber CSS). Ohne dieses Skript ist alles sichtbar.
   - Lesefortschritt im Artikel, Bildwechsel auf der Produktseite, Warenkorb-Zahl.
   - Raum-Buehne: eine sinnvolle Wortgruppe der Titelzeile wird kursiv und golden gesetzt (nur mit html.hl-stage). */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;
  var vh = function () { return window.innerHeight || 800; };

  /* ---------- Einblenden ---------- */
  var SKIP = '.hl-section-header, .hl-section-footer, .hl-section-band, [class*="rooms"], [class*="house"], [class*="floorplan"], [class*="about-flow"], [class*="flur"]';

  var SKIP_INNER = '[class*="rooms"], [class*="house"], [class*="floorplan"], [class*="about-flow"], [class*="flur"]';

  function onReady(fn) { if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', fn); else fn(); }

  function cleanup(el) {
    window.setTimeout(function () {
      el.removeAttribute('data-hlm'); el.classList.remove('is-in'); el.style.removeProperty('--hlm-d');
    }, 1800);
  }

  function setup() {
    if (!('IntersectionObserver' in window) || designMode) return;
    var armed = new Map();
    var io = new IntersectionObserver(function (entries) {
      var hits = entries.filter(function (e) { return e.isIntersecting; })
        .sort(function (a, b) { return (a.target.compareDocumentPosition(b.target) & 4) ? -1 : 1; });
      hits.forEach(function (e, i) {
        var trig = e.target, list = armed.get(trig) || [];
        list.forEach(function (cfg) {
          var el = cfg.el;
          el.style.setProperty('--hlm-d', ((cfg.base || 0) + (cfg.stagger ? Math.min(i, 4) * 70 : 0)) + 'ms');
          el.classList.add('is-in');
          cleanup(el);
        });
        io.unobserve(trig); armed.delete(trig);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });

    // trigger: das Element, dessen Sichtbarkeit beobachtet wird (ein beschnittenes Bild meldet sich selbst nie als sichtbar)
    function arm(el, kind, base, stagger, trigger) {
      if (!el || el.hasAttribute('data-hlm') || el.closest('[data-hlm]')) return;
      var trig = trigger || el, r = el.getBoundingClientRect();
      if (r.top < vh() * 0.92) return; // schon sichtbar oder darueber: nicht verstecken
      el.setAttribute('data-hlm', kind);
      var list = armed.get(trig);
      if (!list) { list = []; armed.set(trig, list); io.observe(trig); }
      list.push({ el: el, base: base || 0, stagger: !!stagger });
    }
    var all = function (sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); };

    all('main > .shopify-section').forEach(function (sec) {
      if (sec.matches(SKIP) || sec.querySelector(SKIP_INNER)) return;
      var did = false;
      // Produktzeile: Bild oeffnet sich (Seite wechselt je Zeile), Text steigt danach auf
      all('.hl-prow', sec).forEach(function (row) {
        var media = row.querySelector('.hl-prow__media'), text = row.querySelector('.hl-prow__text');
        var kind = row.classList.contains('hl-prow--stacked') ? 'clip-t' : (row.classList.contains('hl-prow--mirror') ? 'clip-r' : 'clip');
        arm(media, kind, 0, false, row); arm(text, 'rise', 180, false, row); did = true;
      });
      // Kartenraster und Artikelliste: Karten steigen nacheinander auf
      all('.hl-collection__cell, .hl-articles > li', sec).forEach(function (c) { arm(c, 'rise', 0, true); did = true; });
      all('.hl-blog__intro, .hl-room__head', sec).forEach(function (c) { arm(c, 'rise', 0); did = true; });
      // Artikelbild
      all('.hl-article__media', sec).forEach(function (c) { arm(c, 'clip-t', 0, false, c.parentNode); did = true; });
      // Bildband (nicht das Bild selbst): Inhalt steigt nacheinander ein
      var band = sec.querySelector('.hl-band__content');
      if (band) { all(':scope > *', band).forEach(function (c, i) { arm(c, 'rise', i * 90); }); did = true; }
      // alles andere: die Kinder des inneren Rahmens, sonst der erste Block
      if (!did) {
        var inner = sec.querySelector('.hl-page-section__inner, .hl-bundle__inner');
        var kids = inner ? all(':scope > *', inner) : [];
        if (inner && inner.matches('.hl-bundle__inner')) { arm(inner, 'rise', 0); }
        else if (kids.length) kids.forEach(function (c, i) { arm(c, 'rise', Math.min(i, 4) * 80); });
        else {
          var first = Array.prototype.find.call(sec.children, function (c) { return !/^(SCRIPT|STYLE|LINK)$/.test(c.tagName); });
          arm(first, 'rise', 0);
        }
      }
    });
    all('.hl-section-band').forEach(function (sec) {
      var band = sec.querySelector('.hl-band__content');
      if (band) all(':scope > *', band).forEach(function (c, i) { arm(c, 'rise', i * 90); });
    });
  }

  /* ---------- Raum-Buehne: sinnvolle Wortgruppe der Titelzeile golden und kursiv (Text bleibt unveraendert) ----------
     Je Seite und Sprache steht hier, was hervorgehoben wird (freigegeben von Kristin, 26.10.2026). Fehlt der Eintrag oder passt er nicht zum Text, ist es das letzte Wort.
     Die Seite kommt aus data-hls (gesetzt in snippets/hl-variables.liquid, sprachunabhaengig). Nie ein Wort trennen. */
  var GOLD = {
    de: { waesche: 'ohne Hindernislauf.', bad: 'aufgeräumt.', kueche: 'freie Arbeitsfläche', 'alle-produkte': 'gut aussehen.', kontakt: 'steht offen.' },
    en: { waesche: 'without the obstacle course.', bad: 'tidy.', kueche: 'free worktop', 'alle-produkte': 'look good.', kontakt: 'is open.' },
    fr: { waesche: 'sans parcours d\'obstacles.', bad: 'bien rangé.', kueche: 'plan de travail libre', 'alle-produkte': 'être beaux.', kontakt: 'est ouverte.' },
    es: { waesche: 'sin carrera de obstáculos.', bad: 'ordenado.', kueche: 'encimera libre', 'alle-produkte': 'ser bonitos.', kontakt: 'está abierta.' },
    it: { waesche: 'senza percorso a ostacoli.', bad: 'in ordine.', kueche: 'piano di lavoro libero', 'alle-produkte': 'essere belli.', kontakt: 'è aperta.' },
    nl: { waesche: 'zonder hindernisbaan.', bad: 'opgeruimd.', kueche: 'vrij aanrechtblad', 'alle-produkte': 'goed uitzien.', kontakt: 'staat open.' },
    pl: { waesche: 'bez toru przeszkód.', bad: 'schludnie.', kueche: 'wolnego blatu', 'alle-produkte': 'dobrze wyglądać.', kontakt: 'są otwarte.' },
    sv: { waesche: 'utan hinderbana.', bad: 'städat.', kueche: 'ledig bänkyta', 'alle-produkte': 'se bra ut.', kontakt: 'står öppen.' },
    da: { waesche: 'uden forhindringsbane.', bad: 'ryddeligt.', kueche: 'ledig bordplads', 'alle-produkte': 'se godt ud.', kontakt: 'står åben.' },
    cs: { waesche: 'bez překážkové dráhy.', bad: 'pořádek.', kueche: 'volné pracovní plochy', 'alle-produkte': 'dobře vypadat.', kontakt: 'jsou otevřené.' },
    pt: { waesche: 'sem corrida de obstáculos.', bad: 'arrumado.', kueche: 'bancada livre', 'alle-produkte': 'ser bonitos.', kontakt: 'está aberta.' }
  };
  function stageTitle() {
    if (!root.classList.contains('hl-stage')) return;
    var h = doc.querySelector('[id$="__hero"] .hl-band__heading, [id$="__band_slogan"] .hl-band__heading, [id$="__band_door"] .hl-band__heading, .hl-collection__hero-text .hl-collection__title');
    if (!h || h.querySelector('em')) return;
    var t = h.textContent.trim();
    var key = root.getAttribute('data-hls') || '';
    var lang = (root.lang || 'de').slice(0, 2);
    var phrase = GOLD[lang] && GOLD[lang][key];
    var i = phrase ? t.indexOf(phrase) : -1;
    if (i < 0) { i = t.lastIndexOf(' ') + 1; if (i < 1) return; phrase = t.slice(i); }
    var after = t.slice(i + phrase.length);
    h.textContent = '';
    h.appendChild(doc.createTextNode(t.slice(0, i)));
    var em = doc.createElement('em');
    em.className = 'hls-gold' + (after.trim() ? '' : ' hls-end');
    em.textContent = phrase;
    h.appendChild(em);
    if (after) h.appendChild(doc.createTextNode(after));
  }

  /* ---------- Artikel: Lesefortschritt ---------- */
  function progress() {
    var art = doc.querySelector('.hl-article');
    if (!art || reduced) return;
    var bar = doc.createElement('div');
    bar.className = 'hlm-progress'; bar.setAttribute('aria-hidden', 'true');
    doc.body.appendChild(bar);
    var tick = 0;
    var upd = function () {
      tick = 0;
      var r = art.getBoundingClientRect(), span = r.height - vh() * 0.6;
      var p = span > 0 ? Math.min(1, Math.max(0, -r.top / span)) : 0;
      bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    };
    window.addEventListener('scroll', function () { if (!tick) tick = requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  /* ---------- Produktseite: Bilder blenden ueber statt zu springen ---------- */
  function gallery() {
    var g = doc.querySelector('hl-gallery');
    if (!g || designMode) return;
    var wait = function (img) {
      if (!img || img.tagName !== 'IMG') return;
      var done = function () { img.classList.remove('hlm-wait'); };
      img.classList.add('hlm-wait');
      if (img.complete && img.naturalWidth) requestAnimationFrame(function () { requestAnimationFrame(done); });
      else { img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true }); window.setTimeout(done, 2500); }
    };
    Array.prototype.forEach.call(g.querySelectorAll('.hl-gallery__frame img'), function (img) {
      if (!(img.complete && img.naturalWidth)) wait(img);
    });
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        if (m.type === 'attributes' && m.target.tagName === 'IMG' && m.target.closest('.hl-gallery__frame') && m.oldValue !== m.target.getAttribute(m.attributeName)) wait(m.target);
      });
    }).observe(g, { subtree: true, attributes: true, attributeOldValue: true, attributeFilter: ['src', 'srcset'] });
  }

  /* ---------- Warenkorb-Zahl tickt, wenn sie sich aendert ---------- */
  function cartTick() {
    var link = doc.querySelector('[data-hl-cart-link]');
    if (!link || reduced) return;
    var t;
    new MutationObserver(function () {
      link.classList.remove('hlm-tick'); void link.offsetWidth; link.classList.add('hlm-tick');
      window.clearTimeout(t); t = window.setTimeout(function () { link.classList.remove('hlm-tick'); }, 500);
    }).observe(link, { childList: true, characterData: true, subtree: true });
  }

  onReady(function () {
    try { stageTitle(); } catch (e0) { /* nur Optik */ }
    try { setup(); } catch (e) { /* Bewegung ist Beiwerk: nie die Seite stoeren */ }
    try { progress(); gallery(); cartTick(); } catch (e2) { /* siehe oben */ }
  });
})();

/* Homellence Masslinien (V19.1, 27.10.2026) - steuert Abschnitt 10 in hl-motion.css
   - Eyebrow mit Massangabe ("2,8 cm an der Wand") bekommt eine Masslinie; Text bleibt unveraendert.
   - Linien unterhalb des ersten Bildschirms zeichnen sich einmal, wenn sie ins Bild kommen; sonst stehen sie fertig da.
   - Groessenwahl in cm: Linie zeigt die gewaehlte Laenge im Verhaeltnis zur laengsten. */
(function () {
  'use strict';
  var doc = document;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;
  var DIM = /^\s*\d+(?:[.,]\d+)?\s*cm\b/i;
  var CM = /^\s*(\d+(?:[.,]\d+)?)\s*cm\s*$/i;
  var each = function (sel, fn) { Array.prototype.forEach.call(doc.querySelectorAll(sel), fn); };
  var num = function (s) { return parseFloat(s.replace(',', '.')); };

  function lines() {
    each('.hl-story-panel__eyebrow', function (e) {
      if (!DIM.test(e.textContent) || e.querySelector('.hlm-dim')) return;
      var s = doc.createElement('span');
      s.className = 'hlm-dim'; s.setAttribute('aria-hidden', 'true');
      e.appendChild(s);
    });
    if (reduced || designMode || !('IntersectionObserver' in window)) return;
    var vh = window.innerHeight || 800, seen = [];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        Array.prototype.forEach.call(en.target.querySelectorAll('.hlm-wait'), function (el, i) {
          el.style.setProperty('--hlm-d', (150 + Math.min(i, 5) * 90) + 'ms');
          el.classList.add('hlm-go');
        });
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    each('.hlm-dim, .hl-ratings__scale', function (el) {
      if (el.getBoundingClientRect().top < vh * 0.92) return; // schon sichtbar: fertig stehen lassen
      el.classList.add('hlm-wait');
      var trig = el.closest('.hl-ratings__grid, .hl-story-panel__text') || el.parentNode;
      if (seen.indexOf(trig) < 0) { seen.push(trig); io.observe(trig); }
    });
  }

  function ruler() {
    each('[data-hl-option-group]', function (g) {
      var inputs = g.querySelectorAll('[data-hl-option-input]'), list = g.querySelector('.hl-option__list');
      if (inputs.length < 2 || !list || g.querySelector('.hlm-ruler')) return;
      var max = 0;
      for (var i = 0; i < inputs.length; i++) {
        var m = CM.exec(inputs[i].value);
        if (!m) return; // keine reine cm-Option (Farbe, Form): nichts tun
        max = Math.max(max, num(m[1]));
      }
      if (!max) return;
      var r = doc.createElement('div');
      r.className = 'hlm-ruler'; r.setAttribute('aria-hidden', 'true');
      r.innerHTML = '<i></i><b></b>';
      list.parentNode.insertBefore(r, list.nextSibling);
      var set = function () {
        var c = g.querySelector('[data-hl-option-input]:checked'), m = c && CM.exec(c.value);
        if (m) r.style.setProperty('--hlm-s', (num(m[1]) / max).toFixed(4));
      };
      set();
      g.addEventListener('change', set);
      requestAnimationFrame(function () { requestAnimationFrame(function () { r.classList.add('hlm-live'); }); });
    });
  }

  var go = function () {
    try { lines(); } catch (e) { /* nur Optik */ }
    try { ruler(); } catch (e2) { /* nur Optik */ }
  };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', go); else go();
})();

/* Homellence Logo vor dem Slogan (V19.1, 27.10.2026, Version 2) - steuert Abschnitt 11 in hl-motion.css
   - hl-rooms.js gibt den Fortschritt am Scroll vor: --hl-lg (Logo zeichnen, 0..1) und --hl-lz (herauszoomen, 0..1).
   - Das Logo zeichnet sich gross in der Mitte der Buehne und zoomt dann an seinen Platz ueber dem Slogan.
   - Ohne diese Werte (Theme-Editor, "Bewegung reduzieren", ohne JS) steht das Logo einfach ueber dem Slogan. Texte bleiben unveraendert. */
(function () {
  'use strict';
  var doc = document;
  var SVGNS = 'http://www.w3.org/2000/svg';
  // Anteile an der Zeichnung: Dach, Wand, vier Fenster; danach Fuellung und Schriftzug
  var PARTS = [[0, 0.45], [0.23, 0.43], [0.34, 0.57], [0.39, 0.61], [0.43, 0.66], [0.48, 0.7]];
  var FILL = [0.55, 0.82], WORD = [0.6, 1], BIG = 0.75; // BIG: so viel groesser steht das Logo vor dem Herauszoomen
  var seg = function (v, r) { return Math.min(1, Math.max(0, (v - r[0]) / (r[1] - r[0]))); };
  var io3 = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };

  // Das Haussymbol ist eine einzige Form; fuer die Zeichnung wird sie in ihre Teile zerlegt (gleiche Optik)
  function split(svg) {
    var src = svg && svg.querySelector('path');
    if (!src) return null;
    var parts = src.getAttribute('d').split(/Z\s*(?=M)/i).map(function (s) {
      s = s.trim(); if (!/Z$/i.test(s)) s += 'Z';
      var xy = s.slice(1).trim().split(/[\s,]+/);
      return { d: s, x: parseFloat(xy[0]), y: parseFloat(xy[1]) };
    });
    if (parts.length !== PARTS.length) return null; // Logo geaendert: lieber gar nicht zeichnen
    parts.sort(function (a, b) { return b.d.length - a.d.length; });
    var roof = parts.shift();
    parts.sort(function (a, b) { return ((a.x < 30 ? -1 : 0) - (b.x < 30 ? -1 : 0)) || (a.y - b.y) || (a.x - b.x); });
    parts.unshift(roof);
    var els = parts.map(function (p) {
      var el = doc.createElementNS(SVGNS, 'path');
      el.setAttribute('d', p.d); el.setAttribute('fill', 'currentColor'); el.setAttribute('pathLength', '1');
      svg.appendChild(el);
      return el;
    });
    src.remove();
    return els;
  }

  function setup(sl) {
    var logo = sl.querySelector('.hl-rooms__logo');
    if (!logo || logo.hasAttribute('data-hlm-logo')) return;
    logo.setAttribute('data-hlm-logo', '');
    var house = logo.querySelector('.hl-rooms__logo-house'), word = logo.querySelector('.hl-rooms__logo-word');
    var paths = null, dy = 0, last = '', mo;
    // Abstand von der Logo-Mitte zur Buehnen-Mitte: dort steht das grosse Logo
    var measure = function () {
      var keep = logo.style.transform; logo.style.transform = 'none';
      var m = logo.getBoundingClientRect(), st = sl.closest('.hl-rooms__stage');
      var s = st ? st.getBoundingClientRect() : { top: 0, height: window.innerHeight };
      dy = (s.top + s.height / 2) - (m.top + m.height / 2);
      logo.style.transform = keep;
    };
    var render = function () {
      var lgv = sl.style.getPropertyValue('--hl-lg');
      if (lgv === '') return; // hl-rooms.js steuert (noch) nicht: Logo bleibt, wie es ist
      var lzv = sl.style.getPropertyValue('--hl-lz'), key = lgv + '|' + lzv;
      if (key === last) return;
      last = key;
      if (!paths) {
        paths = split(house);
        if (!paths || !word) { mo.disconnect(); return; }
        logo.classList.add('is-drawn-live');
        measure();
      }
      var g = parseFloat(lgv) || 0, z = io3(parseFloat(lzv) || 0), f = io3(seg(g, FILL));
      paths.forEach(function (p, i) {
        p.style.strokeDashoffset = (1 - io3(seg(g, PARTS[i]))).toFixed(4);
        p.style.fillOpacity = f.toFixed(3);
        p.style.strokeOpacity = (g > 0 ? 1 - f : 0).toFixed(3);
      });
      var w = io3(seg(g, WORD));
      word.style.webkitMaskPosition = word.style.maskPosition = ((1 - w) * 100).toFixed(2) + '% 0';
      logo.style.transform = 'translateY(' + (dy * (1 - z)).toFixed(1) + 'px) scale(' + (1 + BIG * (1 - z)).toFixed(3) + ')';
    };
    mo = new MutationObserver(render);
    mo.observe(sl, { attributes: true, attributeFilter: ['style'] });
    window.addEventListener('resize', function () { if (paths) { measure(); last = ''; render(); } });
    render();
  }

  var init = function () { Array.prototype.forEach.call(doc.querySelectorAll('.hl-rooms__slogan'), function (sl) { try { setup(sl); } catch (e) { /* nur Optik */ } }); };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();

/* Homellence Ueber uns (V19.1, 27.10.2026) - steuert Abschnitt 12 in hl-motion.css
   - Markenkarte: der goldene Schriftzug schreibt sich, waehrend er von 85 % auf 45 % der Bildhoehe wandert (vorher blendet die Karte ein).
     Nur vorwaerts: einmal geschrieben, bleibt er stehen. Ist er beim Laden schon zu sehen, steht er fertig da.
   - Torbogen oben: einmal beim Laden zeichnen sich die zwei Goldlinien von der Mitte der Schwelle nach aussen, die Seiten hoch
     und ueber den Bogen bis zum Scheitel; die Flaeche dunkelt ein, dann steigt der Satz ein (2,4 s).
   - Nicht im Theme-Editor und nicht bei "Bewegung reduzieren". Texte bleiben unveraendert. */
(function () {
  'use strict';
  var doc = document;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || (window.Shopify && window.Shopify.designMode)) return;
  var SVGNS = 'http://www.w3.org/2000/svg';
  var io3 = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };

  function pen() {
    var mark = doc.querySelector('.hl-signature__mark');
    if (!mark || mark.getBoundingClientRect().top < window.innerHeight * 0.85) return;
    mark.classList.add('hlm-pen');
    var best = 0, tick = 0, on;
    var upd = function () {
      tick = 0;
      var h = window.innerHeight, p = Math.min(1, Math.max(0, (h * 0.85 - mark.getBoundingClientRect().top) / (h * 0.4)));
      if (p <= best) return;
      best = p;
      var w = io3(p);
      mark.style.webkitMaskPosition = mark.style.maskPosition = ((1 - w) * 100).toFixed(2) + '% 0';
      if (best >= 1) {
        window.removeEventListener('scroll', on);
        mark.classList.remove('hlm-pen');
        mark.style.removeProperty('mask-position'); mark.style.removeProperty('-webkit-mask-position');
      }
    };
    on = function () { if (!tick) tick = requestAnimationFrame(upd); };
    window.addEventListener('scroll', on, { passive: true });
    upd();
  }

  function arch() {
    var c = doc.querySelector('[id$="__band_path"] .hl-band__content');
    if (!c) return;
    var cs = getComputedStyle(c), r0 = parseFloat(cs.borderTopLeftRadius);
    if (!(r0 > 40) || c.getBoundingClientRect().top > window.innerHeight) return; // kein Bogen oder nicht im ersten Bild
    var ca = getComputedStyle(c, '::after'), e = -parseFloat(ca.top) || 0, R0 = parseFloat(ca.borderTopLeftRadius) || r0 + e;
    var svg = doc.createElementNS(SVGNS, 'svg');
    svg.setAttribute('class', 'hlm-arch__svg'); svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
    var paths = [];
    ['hlm-arch__out', 'hlm-arch__in'].forEach(function (cls) {
      for (var i = 0; i < 4; i++) {
        var p = doc.createElementNS(SVGNS, 'path');
        p.setAttribute('class', cls); p.setAttribute('pathLength', '1');
        svg.appendChild(p); paths.push(p);
      }
    });
    // Vier Wege je Bogen, alle von der Mitte aus: Schwelle links/rechts, Bogen links/rechts (Seite hoch, ueber die Rundung zum Scheitel)
    // Rundung wie im CSS: Radius verkleinert, wenn der Kasten schmaler oder niedriger ist
    var ways = function (x, y, w, h, r) {
      var rr = r * Math.min(1, w / (2 * r), h / r), m = x + w / 2, b = y + h, n = function (v) { return v.toFixed(2); };
      return [
        'M' + n(m) + ' ' + n(b) + 'H' + n(x),
        'M' + n(m) + ' ' + n(b) + 'H' + n(x + w),
        'M' + n(x) + ' ' + n(b) + 'V' + n(y + rr) + 'A' + n(rr) + ' ' + n(rr) + ' 0 0 1 ' + n(x + rr) + ' ' + n(y) + 'H' + n(m),
        'M' + n(x + w) + ' ' + n(b) + 'V' + n(y + rr) + 'A' + n(rr) + ' ' + n(rr) + ' 0 0 0 ' + n(x + w - rr) + ' ' + n(y) + 'H' + n(m)
      ];
    };
    var bw = parseFloat(cs.borderTopWidth) || 0; // die aeussere Linie sitzt am Innenrand des Rahmens (absolute Lage)
    var shape = function () {
      var w = c.offsetWidth, h = c.offsetHeight, W = w - 2 * bw + 2 * e, H = h - 2 * bw + 2 * e;
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      svg.style.left = svg.style.top = -e + 'px';
      svg.style.width = W + 'px'; svg.style.height = H + 'px';
      // Linien liegen mittig auf den 1-px-Rahmen
      var d = ways(0.5, 0.5, W - 1, H - 1, R0 - 0.5).concat(ways(e - bw + 0.5, e - bw + 0.5, w - 1, h - 1, r0 - 0.5));
      paths.forEach(function (p, i) { p.setAttribute('d', d[i]); });
    };
    shape();
    // erst ausblenden, dann den Uebergang einschalten: sonst blendet die Flaeche sichtbar aus, bevor sie einblendet
    c.classList.add('hlm-arch-lines', 'hlm-arch-bg');
    void c.offsetWidth;
    c.classList.add('hlm-arch');
    c.insertBefore(svg, c.firstChild);
    window.addEventListener('resize', shape);
    window.setTimeout(function () { c.classList.remove('hlm-arch-bg'); }, 600);
    window.setTimeout(function () {
      window.removeEventListener('resize', shape);
      c.classList.remove('hlm-arch-lines');
      svg.remove();
    }, 2400);
  }

  var go = function () {
    try { arch(); } catch (e) { /* nur Optik */ }
    try { pen(); } catch (e2) { /* nur Optik */ }
  };
  // erst nach DOMContentLoaded: dann hat hl-about-flow.js (laedt nach diesem Skript) den Bogen und das Seitenlayout gesetzt
  if (doc.readyState === 'complete') go(); else doc.addEventListener('DOMContentLoaded', go);
})();
